import MediaLibraryDelete from './MediaLibraryDelete';

export default MediaLibraryDelete;
